import { useNavigate } from 'react-router-dom'
import { Service } from '../../../../types'

type ReturnType = {
  handleInitialClick: () => void
  handleInProgressClick: () => void
  handleCompletedClick: (categoryId: string) => void
}

type Props = {
  service: Service
}

export const useResumeDistributionActions = ({ service }: Props): ReturnType => {
  const navigate = useNavigate()

  const handleInitialClick = () => {
    navigate('/resume-distribution')
  }

  const handleInProgressClick = () => {
    navigate('/resume-distribution/dashboard')
  }

  const handleCompletedClick = (categoryId: string) => {
    navigate(service.getNextActionUrl({ categoryId }))
  }

  return {
    handleInitialClick,
    handleInProgressClick,
    handleCompletedClick,
  }
}
